// @flow

export function isUserInputError(error: string): boolean {
  switch (error) {
    case 'BP-DR-13':
    case 'BP-DR-15':
    case 'BP-DR-17':
    case 'BP-DR-22':
    case 'BP-DR-23':
    case 'BP-DR-24':
    case 'BP-DR-25':
    case 'BP-DR-26':
    case 'BP-DR-27':
    case 'BP-DR-28':
    case 'BP-DR-29':
    case 'BP-DR-31':
    case 'BP-DR-32':
    case 'BP-DR-51':
    case 'BP-DR-55':
    case 'BP-DR-67':
    case 'BP-DR-75':
    case 'BP-DR-76':
    case 'BP-DR-95':
    case 'BP-DR-97':
    case 'BP-DR-98':
    case 'BP-DR-100':
    case 'BP-DR-101':
    case 'BP-DR-172':
    case 'BP-DR-174':
      return true;
    default:
      return false;
  }
}
